export  class ManageTripIntialRequest{

    constructor()
    {
        this.requestObject ={
            "PNR" : null,
            "lastName":null
          }
    }
}